<template>
  <!-- Queue Pass View - Shown when the pass is in queue status -->
  <QueueWrapper class="p-4">
    <!-- Status bar showing queue message and time -->
    <div
      class="bg-white p-3 rounded-30 d-flex justify-content-between align-items-center"
    >
      <!-- Queue status message -->
      <div class="active-pass-muted-on-light">
        {{ $t("common.currently_waiting_in_line") }}
      </div>

      <!-- Right section with cancel request option and timer -->
      <div class="d-flex align-items-center flex-shrink-0">
        <!-- Cancel request button -->
        <button
          type="button"
          class="active-pass-muted-on-light d-flex align-items-center cursor-pointer bg-transparent border-0 p-0"
          data-test-id="student-active-pass-cancel-request"
          :aria-label="$t('common.cancel_request')"
          @click="$emit('open-cancel-modal')"
        >
          <i class="flaticon-forbidden text-red me-1 mb-1" aria-hidden="true" />
          {{ $t("common.cancel_request") }}
        </button>
      </div>
    </div>

    <!-- Pass information container -->
    <div
      class="bg-white rounded-30 d-flex flex-column justify-content-between align-items-center m-0 mt-3"
    >
      <!-- Comments section -->
      <PassCommentsList :comments="comments" />

      <!-- Timer component -->
      <PassTimer
        :active-pass="activePass"
        :time-in-pass="timeInPass"
        :current-status="currentStatus"
        :is-pass-long-running="isPassLongRunning"
        :pin-attempts-count="pinAttemptsCount"
        :is-active-auto-check-in-module="isActiveAutoCheckInModule"
      />
    </div>
  </QueueWrapper>
</template>

<script>
import QueueWrapper from "@/v3components/QueueWrapper.vue"
import PassCommentsList from "./PassCommentsList.vue"
import PassTimer from "./PassTimer.vue"

export default {
  name: "QueuePassView",
  components: {
    QueueWrapper,
    PassCommentsList,
    PassTimer
  }
}
</script>

<script setup>
defineProps({
  activePass: {
    type: Object,
    default: () => ({})
  },
  comments: {
    type: Array,
    default: () => []
  },
  timeInPass: {
    type: String,
    default: ""
  },
  currentStatus: {
    type: String,
    default: ""
  },
  isPassLongRunning: {
    type: Boolean,
    default: false
  },
  pinAttemptsCount: {
    type: Number,
    default: 0
  },
  isActiveAutoCheckInModule: {
    type: Boolean,
    default: false
  }
})

// Define emits
defineEmits(["open-cancel-modal", "auto-approve"])
</script>
